import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "row p-2" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-md-6"
}
const _hoisted_4 = { class: "form-group row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "medicare-number",
  class: "col-form-label col-12 col-md-5 text-md-end text-sm-start"
}, "Select Supply ", -1 /* HOISTED */)
const _hoisted_6 = { class: "col-12 col-md-7" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "table table-responsive-md border border-gray" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Equipment Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Unit Cost"),
    /*#__PURE__*/_createElementVNode("th", null, "Formulary"),
    /*#__PURE__*/_createElementVNode("th", null, "Related"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", null, "End Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _component_SupplyTableRow = _resolveComponent("SupplyTableRow")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_FormSection, {
      title: "Supply",
      "full-height": false
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isEditAllowed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getSupplyList,
                      value: _ctx.selectionSupply,
                      disabled: _ctx.showSupplyInputRow,
                      "character-limit": 3,
                      onValueChanged: _ctx.selectionSupplyChanged
                    }, null, 8 /* PROPS */, ["getData", "value", "disabled", "onValueChanged"])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createCommentVNode(" EMPTY "),
              (_ctx.supplies.length == 0 && !_ctx.showSupplyInputRow)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                    _createVNode(_component_TableEmpty, {
                      "col-span": _ctx.columns,
                      component: "supply",
                      "secondary-message": "No Supply Added"
                    }, null, 8 /* PROPS */, ["col-span"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" NEW "),
              (_ctx.showSupplyInputRow)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                    _createVNode(_component_SupplyTableRow, {
                      supply: _ctx.savetoAdd,
                      "is-new-supply": true,
                      "update-supply": _ctx.saveNewSupply,
                      "is-edit-allowed": _ctx.isEditAllowed,
                      "cancel-new-supply": _ctx.cancelNewSupply,
                      columns: _ctx.columns
                    }, null, 8 /* PROPS */, ["supply", "update-supply", "is-edit-allowed", "cancel-new-supply", "columns"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" DATA "),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supplies, (supply) => {
                  return (_openBlock(), _createBlock(_component_SupplyTableRow, {
                    supply: supply,
                    "is-edit-allowed": _ctx.isEditAllowed,
                    "update-supply": _ctx.updateSupply,
                    "delete-supply-from-list": _ctx.deleteSupplyFromList,
                    columns: _ctx.columns
                  }, null, 8 /* PROPS */, ["supply", "is-edit-allowed", "update-supply", "delete-supply-from-list", "columns"]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}